/**
 * Service for direct access to the fetch API.
 */

import fetch from 'isomorphic-fetch';

export default {
  get: (url, params = {}) => fetch(url, { ...params, credentials: 'same-origin' }),
};



// WEBPACK FOOTER //
// ./book/src/commons/rest/restService.js